/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeformnotelabel3Inputs */

const en_outcomeformnotelabel3 = /** @type {(inputs: Outcomeformnotelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything we should know? (optional)`)
};

const pt_outcomeformnotelabel3 = /** @type {(inputs: Outcomeformnotelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais alguma coisa que devamos saber? (opcional)`)
};

/**
* | output |
* | --- |
* | "Anything we should know? (optional)" |
*
* @param {Outcomeformnotelabel3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformnotelabel3 = /** @type {((inputs?: Outcomeformnotelabel3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformnotelabel3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformnotelabel3(inputs)
	return pt_outcomeformnotelabel3(inputs)
});
export { outcomeformnotelabel3 as "outcomeFormNoteLabel" }